/**
 * Single source of truth for locales (CLAUDE.md → Languages & Locales). Middleware, routing, sitemap, hreflang,
 * Stripe and invoice language mapping derive from this list. English is the source language, the default and
 * the fallback for everything.
 */
export const locales = ['en', 'de', 'fr', 'es', 'it', 'hu'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'en';

/** Language names in their own language, for the language switcher */
export const localeNames: Record<Locale, string> = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  hu: 'Magyar',
};

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (locales as readonly string[]).includes(value);
}

const LOCALE_PREFIX = new RegExp(`^/(${locales.join('|')})(?=/|$)`);

/** Locale of a pathname such as `/de/products`, or null */
export function localeFromPathname(pathname: string): Locale | null {
  return (LOCALE_PREFIX.exec(pathname)?.[1] as Locale | undefined) ?? null;
}

/** Pathname without its locale prefix: `/de/products` → `/products`, `/de` → `` */
export function stripLocale(pathname: string): string {
  return pathname.replace(LOCALE_PREFIX, '');
}
